import { Box } from '@wix/design-system';
import type { FC } from 'react';
import React, { useState } from 'react';
import { SliderWithInput, UiComponentsProvider } from 'wix-rich-content-ui-components';

export type SliderModalProps = {
  value: number;
  onChange: (value: number) => void;
  min: number;
  max: number;
};

export const SliderModal: FC<SliderModalProps> = ({ onChange, value, min, max }) => {
  const [state, setState] = useState(value);

  return (
    <UiComponentsProvider>
      <Box width="310px">
        <SliderWithInput
          min={min}
          max={max}
          label={null}
          sliderDataHook="itemsPerRowSlider"
          inputDataHook="itemsPerRowInput"
          onChange={value => {
            setState(() => {
              onChange(value);
              return value;
            });
          }}
          value={state}
        />
      </Box>
    </UiComponentsProvider>
  );
};
